import { render, staticRenderFns } from "./AddContactNote.vue?vue&type=template&id=140e7b79"
import script from "./AddContactNote.vue?vue&type=script&lang=js"
export * from "./AddContactNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports